import Head from "next/head";
import { useRouter } from "next/router";
import { Col, Container, Row, Card } from "react-bootstrap";
import ProductList from "../../../components/ProductList";
import InnerLayout from "../../../components/InnerPageLayout";
import styles from "../../../styles/products.module.css";
import Icon from "react-icons-kit";
import { th } from "react-icons-kit/fa";
import * as FormData from "form-data";
import { authHeader } from "../../../_helpers";
import CategoryLinks from "../../../components/CategoryLinks";
import CustomizedAccordions from "../../../components/accordion";
import { Link } from "@material-ui/core";
import ProductSearch from "../../../components/ProductSearch";
import Videos from "../../../components/Videos";
import TestimonialSlider from "../../../components/TestimonialSlider";

function brand({
  testimonials,
  seo_title,
  meta_description,
  meta_keywords,
  content,
  page_title,
  prodList,
  deviceType,
  faqs,
}) {
  const router = useRouter();
  const brand = router.query.brand;
  const ldjson = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => {
      return {
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answer,
        },
      };
    }),
  };
  return (
    <>
      <Head>
        <title>{seo_title}</title>
        <meta name="description" content={meta_description} />
        <meta name="Keywords" content={meta_keywords} />
        <link rel="canonical" href={`/sell-used-tablets/${brand}`} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(ldjson) }}
        />
      </Head>
      <InnerLayout innerPage={true} deviceType={deviceType}>
        <section className="srchbarsec">
          <div className="py-md-5 py-4" style={{ backgroundColor: '#0474B4' }}>
            <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-10 col-lg-6">
                      <ProductSearch />
                  </div>
                </div>
            </div>
          </div> 
          <div className="pt-3">
              <div className="container">
                  <h1 className="mb-1 text-dark fw-600">{page_title}</h1>
                  <div className="d-flex align-items-center gap-1 breadcumb text-default-red">
                      <Link href="/">
                          <a className="text-default-red">Home</a>
                      </Link>
                      <span>/</span>
                      <span>{page_title}</span>
                  </div>
              </div>
          </div>
        </section>
        <section className="py-4">
          <div className="container">
            <ProductList catslug="sell-used-tablets" brand={brand} prodList={prodList}/>
          </div>
        </section>
        <section className="bg-light py-4">
          <div className="container">
            <div dangerouslySetInnerHTML={{ __html: content,}}></div>
          </div>
        </section>
        <section className="py-4">
          <div className="container">
            <h2 className="mb-3 fw-600 text-dark">Frequently Asked Questions</h2>
            <CustomizedAccordions faqs={faqs} />
          </div>
        </section>
        <section className="py-4 bg-default-red text-center">
          <div className="container">
            <h2 className="mb-3 fw-600 text-white">Sell Used Gadgets</h2>
            <div className="mx-auto col-md-10 col-lg-8 p-0"><CategoryLinks /></div>
          </div>
        </section>
        <section className="py-4 testisec">
            <div className="container"> 
              <div className="position-relative">
                <div className="testititsec text-center text-lg-left w-100">
                  <h2 className="mb-md-3 mb-2 h4 fw-600">What Our Users Say</h2>
                  <div className="text-dark mb-md-3 mb-2 testisubtit">Join our <strong className="text-default">600,000+ satisfied customers</strong>. Discover why they trust Budli for their tech needs</div>
                </div>
              </div>
              <TestimonialSlider slideperpage="2" testimonials={testimonials} />
            </div>
        </section>
        <section className="py-4 bg-light videosec mb-4">
            <div className="container">
              <div className="position-relative">
                <div className="videosecinr text-center text-lg-left w-100">
                  <h2 className="mb-2 h4 fw-600">Media & Customer Insights</h2>
                </div>
              </div>
              <Videos/>
            </div>
        </section>
      </InnerLayout>
    </>
  );
}

export async function getServerSideProps(context) {

  const testiapiUrl = `${process.env.NEXT_PUBLIC_API_URL}testimonials/allTestimonials/X-API-KEY/${process.env.NEXT_PUBLIC_API_KEY}/type/text/limit/10`;
  const testires = await fetch(testiapiUrl);
  const testimonials = await testires.json();


  const { brand } = context.params;
  const apiUrl = `${process.env.NEXT_PUBLIC_API_URL}brands/brandDetails/X-API-KEY/${process.env.NEXT_PUBLIC_API_KEY}/brand/${brand}/catSlug/sell-used-tablets`;

  // Fetch data from external API
  const res = await fetch(apiUrl);
  const data = await res.json();

  var formData = new FormData();
  formData.append("catSlug", "sell-used-tablets");
  formData.append("brandSlug", brand);
  formData.append("sortBy", "default");
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: formData,
  };

  const prodApiUrl = `${process.env.NEXT_PUBLIC_API_URL}products/productList`;

  // Fetch data from external API
  const prodData = await fetch(prodApiUrl, requestOptions);
  if (!prodData.ok) {
    return {
      redirect: {
        permanent: false,
        destination: "/sell-used-tablets",
      },
    };
  }
  const prodList = await prodData.json();

  // Detect device type in server side
  const UA = context.req.headers["user-agent"];
  const isMobile = Boolean(
    UA.match(/Android|BlackBerry|iPhone|Opera Mini|IEMobile|WPDesktop/i)
  );
  // Pass data to the page via props
  return {
    props: {
      testimonials,
      seo_title: data.seo_title,
      meta_description: data.meta_description,
      meta_keywords: data.meta_keywords,
      content: data.description,
      page_title: data.page_title,
      prodList,
      deviceType: isMobile ? "mobile" : "desktop",
      faqs: data.faqs ? data.faqs : "",
    },
  };
}

export default brand;